import { defineStore } from 'pinia'
import { supabase } from '../supabase'

export const useTemplateStore = defineStore('template', {
	state: () => ({
		templates: []
	}),
	actions: {
		async fetchTemplates() {
			const { data } = await supabase.from('templates').select('*')
			if (data) this.templates = data
		},
		getTemplateById(id) {
			return this.templates.find((t) => t.id === id) || null
		}
	}
})
